export default __webpack_public_path__ + "static/media/Nathan Disner.90f3267f.jpeg";